module.exports = __webpack_public_path__ + "static/media/epoch_landing1.c37aede4.png";